export const namespaceCmeData = 'http://schemas.microsoft.com/office/infopath/2009/WSSList/cmeDataFields';
export const nsAdoDfs = "http://schemas.microsoft.com/office/infopath/2003/ado/dataFields";
